<template>
  <div class="container">
    <common-head :keys.sync='keys' :word.sync='word'></common-head>
    <div class="inner" style="overflow: inherit">
      <div class="search-page">
        <div class="page-left">
          <div class="sticky srch-sure" @click="screenData()"></div>
          <div class="item-box">
            <div class="item-title">
              Type<span class="icon iconfont icon-jiantou"></span>
            </div>
            <div class="item-con">
              <el-tree show-checkbox class="category-tree" node-key="ID" ref="treeType" :data="result.categryList"
                :props="defaultProps" empty-text="NULL"></el-tree>
            </div>
          </div>
          <div class="item-box">
            <div class="item-title">
              Publisher<span class="icon iconfont icon-jiantou"></span>
            </div>
            <div class="item-con-2">
              <el-input placeholder="Please Input" v-model="filterText" class="press-serch" @input="onFilter"></el-input>
              <el-tree show-checkbox class="category-tree public-tree" node-key="ID" ref="treeName"
                :data="result.publisherList.filter(o => o.NAME.indexOf(filterText) > -1).slice(0, moreNo * 10)"
                :props="defaultProps" empty-text="NULL"></el-tree>
              <div class="press-More" @click="onMore"
                v-show="result.publisherList.filter(o => o.NAME.indexOf(filterText) > -1).length > moreNo * 10">
                More...
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="item-title">
              PublisherTime<span class="icon iconfont icon-jiantou"></span>
            </div>
            <div class="item-con-2">
              <el-tree show-checkbox class="category-tree pbTime-tree" node-key="ID" ref="treeYear"
                :data="result.publishTimeList" :props="defaultProps" empty-text="NULL">
              </el-tree>
            </div>
          </div>
        </div>
        <div class="page-right">
          <div class="page-src-head">
            <div class="title">{{ showTotal }} Result</div>
            <div class="opt-px">
              <span class="ti">Order:</span>
              <el-select v-model="sortVal" class="paixu-select" size="mini" @change="screenData()">
                <el-option v-for="(item, index) in options" :key="item.value" :index="index" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="page-src-body">
            <ul class="search-result-list">
              <li class="item" v-for="(item, index) of productData" :key="item.Id">
                <div class="img">
                  <!-- <div class="img-tag1">{{item.sourceopentype ==="01" ? '借阅' : '畅读' }}</div> -->
                  <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.sourceopentype)">
                    <template v-if="item.Cover">
                      <img :src="item.Cover" />
                    </template>
                    <template v-else>
                      <img src="/static/img/np-img.png" />
                    </template>
                    <!-- <span class="img-tag">{{item.ProductTypeText}}</span> -->
                  </a>
                </div>
                <div class="s-info">
                  <div class="name">
                    <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.sourceopentype)"
                      v-html="item.Name"></a>
                    <!-- <el-tag size="mini" type="warning" effect="dark">{{ item.ProductTypeText }}</el-tag> -->
                  </div>
                  <div class="sr-para" v-html="item.Author"></div>
                  <div class="dec" v-if="item.Introduction">{{ $fun.delHtmlTag(item.Introduction) }}</div>
                  <el-button :type="item.IsCollect ? 'danger' : 'primary'" size="mini" @click="$fun.addCollect(item)"
                    v-show="accountShow">{{
                      item.IsCollect ? '- Book shelf' : '+ Book shelf' }}</el-button>
                </div>
              </li>
            </ul>
            <el-empty description="NULL" v-show="productData.length == 0"></el-empty>
            <common-page :pageNo="pageNo" :pageSize="pageSize" :pageTotal="pageTotal"
              @currentChange="changePage"></common-page>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import CommonPage from "common/plugin/pagination";
export default {
  name: "Search",
  components: {
    CommonHead,
    CommonFoot,
    CommonPage,
  },
  data: function () {
    return {
      defaultProps: {
        label: "NAME",
        children: "List",
      },
      pressInput: "",
      options: [
        {
          value: "",
          label: "All-round",
        },
        {
          value: "1",
          label: "Publisher time",
        },
        {
          value: "2",
          label: "Reading volume",
        },
        {
          value: "3",
          label: "Online time",
        },
      ],
      sortVal: "",
      result: {
        categryList: [],
        publisherList: [],
        publishTimeList: [],
      },
      source: {
        categryList: [],
        publisherList: [],
        publishTimeList: [],
      },
      keys: this.$route.query.Key ? this.$route.query.Key : "",
      word: this.$route.query.Word ? this.$route.query.Word : "",
      productData: [],
      filterText: '',
      moreNo: 1,
      pageNo: 1,
      pageSize: 20,
      pageTotal: 0,
      showTotal: 0,
      accountShow: false,
    };
  },
  mounted() {
    const s2 = document.createElement("script");
    s2.type = "text/javascript";
    s2.src = "static/js/sticky.js";
    document.body.appendChild(s2);
    this.loadData();

    //如果不是ip免登录用户
    let userid = this.jwt_decode(window.localStorage.Token).userId;
    if (userid != '13400000001') {
      this.accountShow = true;
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.NAME.indexOf(value) !== -1;
    },
    searchData: function (key, word) {
      this.keys = key; // ? key : this.keys;
      this.word = word; // ? word : this.word;
      this.pageNo = 1;
      this.$refs.treeType.setCheckedKeys([]);
      this.$refs.treeName.setCheckedKeys([]);
      this.$refs.treeYear.setCheckedKeys([]);
      this.loadData();
    },
    screenData: function () {
      this.pageNo = 1;
      this.loadData();
    },
    loadData: function () {
      var params = {
        page: this.pageNo,
        rows: this.pageSize,
        keys: this.keys,
        word: this.word,
        sort: this.sortVal,
        orgId: this.$fun.getMember().orgId,
        isAggs: true
      };
      // if (!params.Word) {
      //   if (params.Word.trim()=='') {
      //   this.$message({
      //     message: "请输入关键词！",
      //     type: "warning",
      //   });
      //   return;
      // }
      // params.Word = "";
      var hitCount = 0;
      if (this.$refs.treeYear.getCheckedNodes().length > 0) { hitCount++; }
      if (this.$refs.treeName.getCheckedNodes().length > 0) { hitCount++; }
      if (this.$refs.treeType.getCheckedNodes().length > 0) { hitCount++; }
      var publishers = [];
      var publishTimes = [];
      if (hitCount > 0) {
        this.$refs.treeYear.getCheckedNodes().forEach((o) => {
          publishTimes.push(o.ID);
        });
        this.$refs.treeName.getCheckedNodes().forEach((o) => {
          publishers.push(o.ID);
        });
        var firstIds = [];
        var secondIds = [];
        var thirdIds = [];
        this.$refs.treeType.getCheckedNodes().forEach((o) => {
          if (firstIds.indexOf(o.TYPE) === -1) {
            firstIds.push(o.TYPE);
          }
          if (o.Node == 2) {
            secondIds.push(o.BASEID);
          }
          if (o.Node == 3) {
            if (secondIds.indexOf(o.ParentId) === -1) {
              thirdIds.push(o.BASEID);
            }
          }
        });
        params.publishers = publishers ? publishers.toString() : "";
        params.publishTimes = publishTimes ? publishTimes.toString() : "";
        params.firstIds = firstIds ? firstIds.toString() : "";
        if (thirdIds) {
          params.thirdIds = thirdIds ? thirdIds.toString() : "";
        } else {
          params.secondIds = secondIds ? secondIds.toString() : "";
        }
      }
      this.$bti.GetElkPage(params).then((res) => {
        if (res.code != 1) {
          return;
        }
        res.data.Data.forEach(function (item) {
          if (item.highlight.soundbookname) {
            item.Name = item.highlight.soundbookname[0];
          }
          if (item.highlight.ebookname) {
            item.Name = item.highlight.ebookname[0];
          }
          if (item.highlight.name) {
            item.Name = item.highlight.name[0];
          }
          if (item.highlight.author) {
            item.Author = item.highlight.author[0];
          }
        });
        this.productData = res.data.Data;
        this.showTotal = res.data.Count;
        this.pageTotal = res.data.Count > 10000 ? 10000 : res.data.Count;
        if (hitCount > 0) {
          if (hitCount > 1) {
            this.resetData(this.result.categryList, res.data.CategryList);
            this.resetData(this.result.publisherList, res.data.PublisherList);
            this.resetData(this.result.publishTimeList, res.data.PublishTimeList);
          } else {
            if (this.$refs.treeType.getCheckedNodes().length > 0) {
              this.resetData(this.result.categryList, this.source.categryList);
              this.resetData(this.result.publisherList, res.data.PublisherList);
              this.resetData(this.result.publishTimeList, res.data.PublishTimeList);
            }
            if (this.$refs.treeName.getCheckedNodes().length > 0) {
              this.resetData(this.result.publisherList, this.source.publisherList);
              this.resetData(this.result.categryList, res.data.CategryList);
              this.resetData(this.result.publishTimeList, res.data.PublishTimeList);
            }
            if (this.$refs.treeYear.getCheckedNodes().length > 0) {
              this.resetData(this.result.publishTimeList, this.source.publishTimeList);
              this.resetData(this.result.categryList, res.data.CategryList);
              this.resetData(this.result.publisherList, res.data.PublisherList);
            }
            this.result.publisherList = this.result.publisherList.slice().sort(function (a, b) {
              return b.Count - a.Count;
            });
          }
        } else {
          this.source.publisherList = JSON.parse(JSON.stringify(res.data.PublisherList));
          this.source.publishTimeList = JSON.parse(JSON.stringify(res.data.PublishTimeList));
          this.source.categryList = JSON.parse(JSON.stringify(res.data.CategryList));

          this.result = JSON.parse(JSON.stringify(this.source));
        }
      });
    },
    changePage: function (val) {
      this.pageNo = val;
      this.loadData();
    },
    changeSize: function (val) {
      this.pageSize = val;
      this.loadData();
    },
    resetData: function (oldData, newData) {
      oldData.forEach(function (item) {
        var isHit = false;
        newData.forEach(function (temp) {
          if (item.ID == temp.ID) {
            item.NAME = temp.NAME;
            item.Count = temp.Count;
            isHit = true;
          }
        });
        if (!isHit) {
          item.NAME = item.NAME.substr(0, item.NAME.indexOf("(")) + "(0)";
          item.Count = 0;
        }
      });
    },
    onMore() {
      this.moreNo++;
    },
    onFilter() {
      this.moreNo = 1;
    }
  },
};
</script>

<style lang="css" scoped>
.search-page {
  position: relative;
  /* padding-bottom: 50px; */
  padding: 30px 0px;

  min-height: 600px;
}

.search-page:after,
.search-press:after,
.search-year:after,
.page-right .page-src-head:after,
.search-result-list .item:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.page-left {
  position: relative;
  float: left;
  width: 265px;
  padding-bottom: 50px;
  padding-left: 15px;
}

.search-page .srch-sure {
  position: relative;
  float: left;
  margin-top: 120px;
  margin-left: -15px;
  width: 33px;
  height: 56px;
  background: url("/static/img/search_sure.png") no-repeat left top;
  z-index: 111;
  cursor: pointer;
}

.page-left .item-box {
  background: #fff;
}

.page-left .item-box:last-child {
  padding-bottom: 30px;
}

.page-left .item-title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
  padding: 0 25px;
  font-size: 16px;
  font-weight: bold;
  position: relative;
}

.page-left .item-box:not(:first-child) .item-title {
  border-top: 1px solid #eee;
}

.page-left .item-title .icon {
  position: absolute;
  right: 20px;
  top: 0px;
  font-size: 20px;
  font-weight: normal;
}

.page-left .item-con {
  padding: 15px 25px;
}

.press-checkList {
  margin-bottom: 10px;
}

.press-checkList .el-checkbox {
  position: relative;
  height: 33px;
  line-height: 33px;
}

.page-left .item-con .press-More {
  color: #0073af;
  cursor: pointer;
  height: 35px;
  line-height: 35px;
  margin-bottom: 6px;
  font-size: 14px;
}

.search-press .el-input {
  width: 135px;
}

.search-press .el-button {
  float: right;
}

.timeSL-list {
  margin-bottom: 10px;
}

.timeSL-list .el-checkbox {
  width: 100%;
  padding: 6px 0px;
}

.search-year .el-input {
  width: 60px;
}

.search-year .el-button {
  float: right;
}

.page-right {
  float: right;
  width: 910px;
  width: calc(100% - 290px);
  background: #fff;
}

.page-right .page-src-head {
  position: relative;
  height: 50px;
  line-height: 50px;
  padding: 0px 30px;
  font-size: 14px;
}

.page-right .page-src-head .opt-px {
  position: absolute;
  right: 30px;
  top: 0px;
}

.page-right .page-src-head .opt-px .ti {
  padding-right: 10px;
}

.page-right .page-src-head .opt-px .el-select {
  width: 150px;
}

.page-src-body {
  padding: 10px 40px;
}

.search-result-list .item {
  padding: 15px 0px;
}

.search-result-list .item .img {
  float: left;
  width: 136px;
  height: 179px;
  overflow: hidden;
  box-shadow: 0px 0px 5px #ccc;
  position: relative;
}

.search-result-list .item .img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg, #409EFF, #409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}

.search-result-list .item .img a {
  display: block;
  cursor: pointer;
  width: 136px;
  height: 179px;
}

.search-result-list .item .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.search-result-list .item .s-info {
  position: relative;
  float: right;
  width: 669px;
  width: calc(100% - 166px);
}

.search-result-list .item .s-info .name {
  height: 35px;
  line-height: 35px;
  max-width: 80%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.search-result-list .item .s-info .name a {
  display: inline-block;
  color: #252525;
  font-size: 14px;
  font-weight: bold;
  max-width: 80%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.search-result-list .item .s-info .name .el-tag {
  position: relative;
  top: -12px;
  margin-left: 15px;
}

.search-result-list .item .s-info .sr-para {
  margin-bottom: 10px;
}

.search-result-list .item .s-info .dec {
  font-size: 14px;
  padding: 15px 0px;
  line-height: 1.8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;
  height: 90px;
}

.search-result-list .item .el-button {
  position: absolute;
  right: 0px;
  top: 10px;
}

.press-serch {
  margin-bottom: 10px;
}

.press-More {
  color: #25a9eb;
  font-weight: bold;
  margin-top: 15px;
  cursor: pointer;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/Search.vue